import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { BillingDetailsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/outputs/shared/billing-details.model';
import { useTranslation } from 'react-i18next';

interface BankingCardProps {
  billingDetails: BillingDetailsModel;
  commissionPercentage: number;
}

export const InvoicingCard = ({
  billingDetails,
  commissionPercentage,
}: BankingCardProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="receipt-check"
        as={HeadingEnum.H2}
        variant={AccentVariantEnum.Accent1}
        text={t('delmonicos-shared-sdk.outputs-customer.holder')}
      />
      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>{t('delmonicos-shared-sdk.outputs-holder.last-name')}</Text>
        <Text>{billingDetails.lastName}</Text>
      </Stack>
      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>{t('delmonicos-shared-sdk.outputs-holder.first-name')}</Text>
        <Text>{billingDetails.firstName}</Text>
      </Stack>
      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>{t('delmonicos-shared-sdk.outputs-holder.address')}</Text>
        <Text>
          {billingDetails.address.address}, {billingDetails.address.zipCode}{' '}
          {billingDetails.address.city} - {billingDetails.address.countryCode}
        </Text>
      </Stack>
      <Divider />
      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-customer.commission-percentage')}
        </Text>
        <Text>{commissionPercentage} %</Text>
      </Stack>
    </Card>
  );
};
